import { render, staticRenderFns } from "./MedicinesTypeAdd.vue?vue&type=template&id=694c7ca2&scoped=true&"
import script from "./MedicinesTypeAdd.vue?vue&type=script&lang=js&"
export * from "./MedicinesTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694c7ca2",
  null
  
)

export default component.exports